import * as authSelectorsV1 from "@rentiohq/shared-frontend/dist/redux/auth/auth.selectors";
import * as contactActions from "@rentiohq/shared-frontend/dist/redux/contact/contact.actions";
import { EContactCustomId } from "@rentiohq/shared-frontend/dist/redux/contact/contact.types";
import * as authSelectors from "@rentiohq/shared-frontend/dist/reduxV2/auth/auth.selectors";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { IRootState } from "../redux/reducers";

enum AUTH_PATHS {
  VerifyPhone = "/auth/verify/phone",
  VerifyEmail = "/auth/verify/email",
  SignIn = "/auth/signin",
}

const AuthenticatedLayout = () => {
  const dispatch = useDispatch();

  const hasAccessToken = useSelector((state: IRootState) =>
    authSelectors.hasAccessToken(state),
  );

  const shouldRefetch = useSelector((state: IRootState) =>
    authSelectors.shouldRefetch(state),
  );

  const user = useSelector((state: IRootState) =>
    authSelectorsV1.getUser(state),
  );

  React.useEffect(() => {
    if (!hasAccessToken) {
      return;
    }

    dispatch(
      contactActions.getContact.actions.start({
        contactId: EContactCustomId.MeMaster,
      }),
    );
  }, [hasAccessToken]);

  React.useEffect(() => {
    if (!hasAccessToken && !shouldRefetch) {
      return;
    }

    dispatch(
      contactActions.getContact.actions.start({
        contactId: EContactCustomId.Me,
      }),
    );
  }, [hasAccessToken, shouldRefetch]);

  const { unverifiedEmail, unverifiedPhone, unverifiedPhoneIsVerifiable } =
    user || {};

  const renderRedirect = (path: string) => {
    const referrer = `${window.location.pathname}${window.location.search}`;
    if (path === AUTH_PATHS.SignIn) {
      return (
        <Navigate
          to={path}
          state={
            referrer.includes("publicId")
              ? {
                  referrer,
                }
              : undefined
          }
        />
      );
    }

    return (
      <Navigate
        to={path}
        state={{
          referrer,
        }}
      />
    );
  };

  if (unverifiedPhone && unverifiedPhoneIsVerifiable) {
    return renderRedirect(AUTH_PATHS.VerifyPhone);
  }

  if (unverifiedEmail) {
    return renderRedirect(AUTH_PATHS.VerifyEmail);
  }

  if (!hasAccessToken || !user) {
    return renderRedirect(AUTH_PATHS.SignIn);
  }

  return <Outlet />;
};

// eslint-disable-next-line import/no-default-export
export default AuthenticatedLayout;
